const isDefined = (x) => x !== void 0 && x !== null;
export {
  isDefined
};
//# sourceMappingURL=is-defined.js.map
